<!-- Sidebar -->
<div class="flex grow shrink-0" id="sidebar_content">
	<div
		class="kt-scrollable-y-auto grow gap-2.5 shrink-0 flex items-center flex-col max-h-[calc(100dvh-10px))] lg:max-h-[calc(100dvh-70px))]">
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-chart-line-star text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Dashboard
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-profile-circle text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Profile
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input active"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-setting-2 text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Account
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-users text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Network
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-security-user text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Plans
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-messages text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Security Logs
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-shop text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Notifications
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-cheque text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				ACL
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-code text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				API Keys
			</span>
		</a>
		<a class="kt-btn kt-btn-ghost kt-btn-icon rounded-full size-10 border border-transparent text-secondary-foreground hover:bg-background hover:[&_i]:text-primary hover:border-input [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-input"
			data-kt-tooltip="" data-kt-tooltip-placement="right" href="https://keenthemes.com/metronic/tailwind/docs/">
			<span class="kt-menu-icon">
				<i class="ki-filled ki-question text-lg">
				</i>
			</span>
			<span class="kt-tooltip" data-kt-tooltip-content="true">
				Docs
			</span>
		</a>
	</div>
</div>
<!-- End of Sidebar -->